import {useQuery, keepPreviousData, type UseQueryOptions, type UseQueryResult} from '@github-ui/react-query'
import {reactFetchJSON} from '@github-ui/verified-fetch'

export type AlertsResponse<Alert> = Alert[]

export interface AlertsQueryRequest {
  path: string
  number?: number
  query?: string
}

export function useAlertsQuery<Alert>(
  request: AlertsQueryRequest,
  options?: Omit<UseQueryOptions<AlertsQueryRequest, Error, AlertsResponse<Alert>>, 'queryKey' | 'queryFn'>,
): UseQueryResult<AlertsResponse<Alert>> {
  return useQuery({
    queryKey: ['item-picker-alerts', request],
    queryFn: async () => {
      const {path, number, query = ''} = request
      const url = new URL(path, window.location.origin)
      if (number !== undefined) {
        url.searchParams.set('number', number.toString())
      } else if (query) {
        url.searchParams.set('query', query)
      }

      const response = await reactFetchJSON(url.href)
      if (!response.ok) {
        throw new Error(`${response.status} on ${response.url}`)
      }
      return response.json()
    },
    placeholderData: keepPreviousData,
    ...options,
  })
}
